import { useEffect, useRef } from 'react';

import { useLanguage } from '../../hooks/useLanguage';
import { useGetUserProfileQuery } from '../../store/api/userApi';

/**
 * Applies `user.language` from GET /users/me to i18n when the server value changes
 * (login, profile update, or account switch). Does not re-apply on every refetch if
 * the server language is unchanged, so a local-only toggle stays until the backend changes.
 */
export function UserLanguageSync() {
  const { changeLanguage } = useLanguage();
  const { data, isSuccess } = useGetUserProfileQuery();
  const lastAppliedKey = useRef<string | null>(null);

  const userId = data?.data?.user?._id;
  const serverLang = data?.data?.user?.language;

  useEffect(() => {
    if (!isSuccess || !userId || !serverLang) return;

    const key = `${userId}:${serverLang}`;
    if (lastAppliedKey.current === key) return;

    lastAppliedKey.current = key;
    changeLanguage(serverLang);
  }, [isSuccess, userId, serverLang, changeLanguage]);

  return null;
}
